import React, {useState, useLayoutEffect} from "react";
import Dropdown from "react-bootstrap/Dropdown";
import "bootstrap/dist/css/bootstrap.min.css";
import "./categoryDropdown.css";
import ICategory from "../../../interfaces/ICategory";
import { useNavigate, Link } from "react-router-dom";

const SubDropdown = ({
  category,
  onItemSelected,
}: {
  category: ICategory;
  onItemSelected: () => void;
}) => {
  const navigate = useNavigate();
  const nav = (evt: React.MouseEvent, url: string) => {
    evt.preventDefault();
    onItemSelected();
    navigate(url);
  };
  const [subCurrentCategoryID, setSubCurrentCategoryID] = useState(window.localStorage.getItem("subCurrentCategoryID"));  
  const [thirdCurrentCategoryID, setThirdCurrentCategoryID] = useState(window.localStorage.getItem("thirdCurrentCategoryID"));  
  useLayoutEffect(() => {
    setSubCurrentCategoryID(window.localStorage.getItem("subCurrentCategoryID"))
    setThirdCurrentCategoryID(window.localStorage.getItem("thirdCurrentCategoryID"))
  })
  type AnchorProps = JSX.IntrinsicElements["a"];
  const CustomToggle = React.forwardRef<HTMLAnchorElement, AnchorProps>(
    ({ children, onClick, href,className }, ref) => (
      <a
        href={href}
        ref={ref}
        className={className}
        onClick={(e) => {
          e.preventDefault();
          onClick && onClick(e);
        }}
      >
        <span className="visually-hidden">{children}</span>
      </a>
    )
  );

  return (
    <Dropdown drop="end" title={category.name}>
      <Link
        to={`/category/${category.categoryTagId}`}
        className= {`${category.categoryTagId==subCurrentCategoryID?"active":""} dropdown-item d-inline-block w-75`}
        onClick={(evt)=>{//onItemSelected()          

          window.localStorage.setItem("subCurrentCategoryID",category.categoryTagId)
          setSubCurrentCategoryID(window.localStorage.getItem("subCurrentCategoryID"))  
          
          window.localStorage.setItem("thirdCurrentCategoryID","")
          setThirdCurrentCategoryID(window.localStorage.getItem("thirdCurrentCategoryID"))          
             
        }}
      >
        {category.menuName}
      </Link>
      <Dropdown.Toggle
        as={CustomToggle}
        className={`${category.categoryTagId==subCurrentCategoryID && window.localStorage.getItem("thirdCurrentCategoryID")!=""?"active":""} dropdown-toggle dropdown-item d-inline-block w-25`}
        href={`/category/${category.categoryTagId}`}
      >
        {category.menuName}
      </Dropdown.Toggle>
      {category.children.length > 0 && (
        <Dropdown.Menu>
          { 
          category.children.map((cat: ICategory, idx: number) => (
            <Dropdown.Item key={cat.categoryTagId} className={`${cat.categoryTagId==thirdCurrentCategoryID?"dropdown-item active":"dropdown-item"}`}
              onClick={(evt) => {               
                window.localStorage.setItem("thirdCurrentCategoryID",cat.categoryTagId)
                setThirdCurrentCategoryID(window.localStorage.getItem("thirdCurrentCategoryID"))   
                nav(evt, `/category/${cat.categoryTagId}`)}}
            >
              {cat.menuName}
            </Dropdown.Item>
          ))}
        </Dropdown.Menu>
      )}
    </Dropdown>
  );
};

export default SubDropdown;
